import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiBaseService } from '../api-base.service';
import ApiOptionsConfig from '../api-options.config';
const BASE_URL = '/companies';
@Injectable({
  providedIn: 'root'
})
export class CompaniesService extends ApiBaseService {
  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(companyId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${companyId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(companyId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${companyId}`), data);
  }

  delete(companyId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${companyId}`));
  }

  me(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/me`), options?.params);
  }

  updateWorkingHours(companyId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${companyId}/working-hours`), data);
  }

  createLogo(companyId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${companyId}/attachments/logo`), formData);
  }

  deleteLogo(companyId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${companyId}/attachments/logo`));
  }

  getLogo(url: string): Observable<string> {
    const headers: { [key: string]: string } = {};
    if (this.accessToken) headers['Authorization'] = `Bearer ${this.accessToken}`;
    return this.httpClient.get<any>(url, { headers }).pipe(
      map((response: any) => (response.data?.attachment?.publicUrl ?? response.attachment?.publicUrl) as string)
    );
  }
}
